const actions = {
  getProducts: async (context, { vendor_id, per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vouchers/products`, {
      params: {
        vendor_id,
        per_page,
        search,
      },
    });

    return response;
  },

  getStockReport: async (
    context,
    { page, perPage, vendor_id, product, saldo }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/reports/stock`, {
      params: {
        page,
        perPage,
        vendor_id,
        product,
        saldo,
      },
    });

    return response;
  },

  mudarEstoque: async (
    context,
    { vendor_id, motivo, observacao, products }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/vendors/manual-stock-movement`, {
      vendor_id,
      motivo,
      observacao,
      products,
    });

    return response;
  },
};

export const ajusteEstoque = {
  namespaced: true,
  actions,
};
